module.exports = __webpack_public_path__ + "static/media/AVAX-BNB.36efd5f2.svg";